import React, { useState, useEffect, useRef } from 'react';
import Icon from '../../../icons';
import './tags_style.css';
import { addClass, removeClass, getInputWidth, convertToTitleCase } from '../../../common/util';

const KEY_BACKSPACE = 8;
const KEY_ENTER = 13;
const KEY_UP = 38;
const KEY_DOWN = 40;

const Tags = (props) => {
    
    const { inputTags = [] } = props;
    const [tags, setTags] = useState(inputTags);
    const [errorTag, setErrorTag] = useState(null)
    const [validationError, setValidationError] = useState({
        type: null,
        name: ""
    })
    const [name, setName] = useState("");
    const [showDropdown, setShowDropdown] = useState(false)
    const [suggestions, setSuggestions] = useState([]);
    const [selectedItem, setSelectedItem]=useState(null);
    const lastSyncedTags = useRef(inputTags);

    const resetValidationError = () => {
        setValidationError({ type: null, name: "" });
        if (validationError.type == "duplicate") {
            const elList = document.querySelectorAll(".tag-wrapper");
            elList.forEach(function (el) {
                removeClass(el, "ReactTags__tag__sametag");
            });
        }
    }
    
    useEffect(() => {
        window.__isReactDndBackendSetUp = false;
    }, []);


    useEffect(() => {
        if (name.length > 0) {
            let list = (props.suggestions || []).filter(item =>
                item.name.toLowerCase().includes(name.toLowerCase()) &&
                !tags.some(tag => tag?.name?.toLowerCase() === item.name.toLowerCase())
            );
            setSuggestions(list);
        }
        else {
            setSuggestions([]);
        }
        setSelectedItem(null);
    }, [name, tags])


    const validateAndAppendTag = (newTag) => {
        if (tags.some(tag => tag?.name?.toLowerCase() == newTag?.name?.toLowerCase())) {
            setValidationError({
                type: "duplicate",
                name: "Cannot add duplicate, Tag already exists."
            })

            var elList = document.querySelectorAll(".tag-wrapper");
            elList.forEach(function (el) {
                if (el?.innerText?.toLowerCase() == newTag?.name?.toLowerCase()) {
                    setErrorTag(el)
                    addClass(el, "ReactTags__tag__sametag")
                }
            });
            return null;
        } else if (newTag.name.length > 50) {
            setValidationError({
                type: "maxLength",
                name: "Skillset should have up to a maximum of 50 characters."

            })
            return null;
        } else if (props.maxskillSet && tags.length >= props.maxskillSet) {
            setValidationError({
                type: "maxSkillSet",
                name: `Maximum ${props.maxskillSet} Skillset is allowed.`
            })
            return null;
        }
        return [...tags, getTagText(newTag)];
    }

    const handleTagAddition = (newTag) => {
        setSuggestions([]);
        const newTags = validateAndAppendTag(newTag);
        if (newTags) {
            setTags(newTags);
            resetValidationError();
            setName('');
        }
    }

    const getTagText=(newTag)=> {
        const tagLabel = convertToTitleCase(newTag.name);
        return{id:newTag.id, name:tagLabel};
    }

    const handleInputChange = (e) => {
        setName(e.target.value);
        if (validationError.type) {
            resetValidationError();
        }
        if (validationError.type === "duplicate") {
            removeClass(errorTag, "ReactTags__tag__sametag")
            setErrorTag(null)
        }

        const inputEl = document.getElementById("formTags_input")
        if (inputEl) {
            let width = getInputWidth(inputEl, "ReactTags__tmp_element")
            if (width > inputEl.getBoundingClientRect().width)
                inputEl.style.width = (width < 92 ? 92 : width) + "px";
        }
    }

    const handleDelete = (i) => {
        const tagsToUpdate = tags.filter((tag, index) => index !== i);
        setTags(tagsToUpdate);
        lastSyncedTags.current = tagsToUpdate;
        props.updateTagForOrg(tagsToUpdate);
    }

    const handleInputBlur = () => {
        let finalTags = tags;
        const trimmedName = name.trim();
        setShowDropdown(false);

        if (trimmedName.length && !isError) {
            const newTag = selectedItem == null
                ? { name: trimmedName }
                : { id: suggestions[selectedItem].id, name: suggestions[selectedItem].name.trim() };
            const newTags = validateAndAppendTag(newTag);
            if (newTags) {
                finalTags = newTags;
                setTags(finalTags);
                setSuggestions([]);
                setName('');
            }
        }

        if (finalTags !== lastSyncedTags.current) {
            lastSyncedTags.current = finalTags;
            props.updateTagForOrg(finalTags);
        }
    }

    const handleInputFocus = () => {
        $("#formTags_input").focus();
    }
    const navigateSuggestions = (keyCode) => {
        const listSize = suggestions.length;
        if (listSize === 0) {
            return;
        }
        let newSelected;
        if (selectedItem == null) {
            newSelected = 0;
        } else if (keyCode === KEY_UP) {
            newSelected = selectedItem === 0 ? 0 : selectedItem - 1;
        } else {
            newSelected = selectedItem === listSize - 1 ? listSize - 1 : (selectedItem + 1) % listSize;
        }
        setSelectedItem(newSelected);

        const listEl = document.getElementById("tags");
        if (newSelected === listSize - 1) {
            return;
        } else if (newSelected === 0) {
            listEl.scrollTo(0, 0);
            return;
        }

        const selectedEl = document.getElementById(suggestions[newSelected].id);
        const scrollTop = listEl.scrollTop;
        const selectedElementTop = selectedEl.offsetTop;
        const selectedElementHeight = selectedEl.offsetHeight;
        const scrollWindowHeight = listEl.offsetHeight;

        if (selectedElementTop > scrollTop + 80 && selectedElementTop + selectedElementHeight < scrollTop + scrollWindowHeight) {
            return;
        }
        listEl.scrollBy(0, keyCode === KEY_UP ? -selectedElementHeight : selectedElementHeight);
    }

    const handleKeyDown = (e) => {        
        if (e.keyCode === KEY_DOWN || e.keyCode === KEY_UP) {
            navigateSuggestions(e.keyCode);
        }else if (name.trim().length && !isError && e.keyCode === KEY_ENTER) {
            const newTag = selectedItem == null
                ? { name: name.trim() }
                : { id: suggestions[selectedItem].id, name: suggestions[selectedItem].name.trim() };
            handleTagAddition(newTag);
        }else if (e.keyCode === KEY_BACKSPACE && name.trim().length === 0 && tags.length > 0) {
            handleDelete(tags.length - 1);
        }
    }

    const toggleHover =(index)=> {
        setSelectedItem(index);
    }

    const isError = validationError?.name?.length > 0;

    return (
        <div className={`formGroup formTags ${isError ? "errorMsg" : ""}`}>
            <div className="wth-12 ">
                <div className="ReactTags__tags react-tags-wrapper">
                    <div className="ReactTags__selected" onClick={()=>handleInputFocus()}>
                        {tags.length > 0 && tags.map((item, index) => {
                            return (
                                item?.name &&
                                <span key={item.id} className="tag-wrapper ReactTags__tag">
                                    {item?.name}
                                    <button className="ReactTags__remove btn-cc btn-cc__transparent" onMouseDown={(e) => e.preventDefault()} onClick={() => handleDelete(index)}><Icon name="close" className="icon" /></button>
                                </span>
                            )
                        })}
                        <div className="ReactTags__tagInput">
                            <input 
                                className="ReactTags__tagInputField" 
                                type="text" 
                                placeholder={tags.length === 0 ? "Choose a Skillset" : ""} 
                                id="formTags_input" 
                                data-automation="input" 
                                data-testid="input"
                                onChange={handleInputChange} 
                                value={name} 
                                onKeyDown={handleKeyDown}
                                onBlur={handleInputBlur}
                                onFocus={() => setShowDropdown(true)}
                            />
                        </div>
                    </div>

                </div>
                {(showDropdown && suggestions.length > 0) &&
                    <div className="mailDropdown select serviceLocation">
                        <div className="mailingSearch serviceLocation  openTop onClick ">
                            <div className="select2-results" id="tags">
                                {
                                    suggestions.map((item, index) => {
                                        return (
                                            <div
                                                className={`btn-cc btn-cc__transparent ${(selectedItem == index  ? 'activeItem':'' )}`} 
                                                id={item.id} 
                                                key={index}
                                                onMouseDown={(e) => { e.preventDefault(); handleTagAddition({ id: item.id, name: item.name.trim() }) }}
                                                onMouseEnter={ ()=>toggleHover(index)} 
                                                onMouseLeave={()=>toggleHover(index)}
                                            >
                                                <div className="drop-down-block rowFlex rowSpaceBetween">
                                                    <span className="skillset-name">{item.name}</span>
                                                    <span className="skillset-no">{item.frequency}</span>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                }
                {isError &&
                    <span className="tag_error">{validationError.name}</span>
                }
            </div>
        </div>)
}


export default Tags;